import { QuestionViewPropsFor } from '@/components/question/view/types';
import { QuestionTypeEnum } from '@/models/Question';
import { useMemo } from 'react';

export type TrueOrFalseAnswerOption = {
  value: 'true' | 'false';
  isSelected: boolean;
};

export function useTrueOrFalseAnswerView(
  props: QuestionViewPropsFor<QuestionTypeEnum.TRUE_OR_FALSE>,
) {
  const { value, mode } = props;
  const onChange = props.mode === 'answering' ? props.onChange : undefined;

  const selectedValue = value == null ? '' : String(value);

  const options = useMemo<TrueOrFalseAnswerOption[]>(
    () => [
      { value: 'true', isSelected: selectedValue === 'true' },
      { value: 'false', isSelected: selectedValue === 'false' },
    ],
    [selectedValue],
  );

  const disabled = mode !== 'answering';

  const handleChange = (next: string) => {
    onChange?.(next === '' ? null : next === 'true');
  };

  return { options, value: selectedValue, handleChange, disabled };
}
